import { defineComponent, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { store } from "~/store/admin/RsyncStore";
import { Log } from "~/extensions/utils";
import { PagingListHelper } from "~/extensions/utils/PagingHelper";
import { MsgBox } from "~/components/MsgBox";
import MyPageTable from "~/components/MyPageTable.vue";
import { HanyoKb, PageID } from "~/extensions/utils/DefineTypes";
import { HanyoHelper } from "~/extensions/utils/HanyoHelper";
import { GetHanyoParam } from "~/api/Common/Commands";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { adminApi } from "~/api/admin/Api";
import { RsyncConditionViewModel } from "./Models/RsyncConditionViewModel";
import { RsyncResult } from "~/api/data/Admin/Rsync/RsyncResult";
import { commonStore } from "~/store/CommonStore";
import MypageBadge from "~/components/MypageBadge.vue";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
const log = Log.create("rsync");
const TargetOperation = HanyoKb.TargetOperation;
export default defineComponent({
    components: {
        MyPageTable,
        MypageBadge,
        BreadcrumbList
    },
    name: "RsyncList",
    beforeRouteEnter(to, from, next) {
        store.clear();
        next();
    },
    setup() {
        const pageName = commonStore.pageName(PageID.resync);
        const top = PageID.top;
        const resync = PageID.resync;
        const router = useRouter();
        // テーブルカラム
        const columns = [
            { name: "targetOperation", align: "center", field: "targetOperation", sortable: true },
            { name: "syncId", label: "同期ID", align: "right", field: "syncId", sortable: true },
            { name: "failureDate", label: "連携失敗日時", align: "center", field: "failureDate", sortable: true },
            { name: "userCd", label: "契約者コード", align: "right", field: "userCd", sortable: true },
            { name: "userName", label: "契約者名", align: "left", field: "userName", sortable: true },
            { name: "buknCd", label: "物件コード", align: "right", field: "buknCd", sortable: true },
            { name: "buknName", label: "物件名", align: "left", field: "buknName", sortable: true },
            { name: "roomNo", label: "号室", align: "left", field: "roomNo", sortable: true },
            { name: "nyukyokeiyakuNo", label: "入居契約No.", align: "right", field: "nyukyokeiyakuNo", sortable: true },
            { name: "nyukyokeiyakuName", label: "入居者名", align: "left", field: "nyukyokeiyakuName", sortable: true },
            { name: "rsyncButton", align: "center", field: "rsyncButton", sortable: false }
        ];
        // 対象操作プルダウン
        let targetOperationList = ref([]);
        const pagingListHelper = new PagingListHelper({ mode: "store", store }, log);
        const rsyncData = ref(new RsyncConditionViewModel());
        // 初期化処理
        const initView = async () => {
            try {
                Loading.show();
                let gethanyoParam = [new GetHanyoParam(HanyoKb.TargetOperation)];
                let hanyoList = await HanyoHelper.getHanyoList(gethanyoParam);
                let targetOperation = hanyoList.GetByHanyoKb(HanyoKb.TargetOperation);
                targetOperationList.value = targetOperation;
                await pagingListHelper.initialize();
            }
            catch (ex) {
                await MsgBox.error(ex.data.errorMessage);
                log.error("find", ex);
            }
            finally {
                Loading.hide();
            }
        };
        //ページング処理
        const onRequest = async (requestData) => {
            Loading.show();
            await pagingListHelper.paging(requestData);
            Loading.hide();
        };
        //検索ボタン押下の処理
        const onSearch = async () => {
            Loading.show();
            await pagingListHelper.search();
            Loading.hide();
        };
        //再同期ボタン押下時の処理
        const onRsync = async (syncId) => {
            try {
                Loading.show();
                const target = store.results.find(x => x.syncId === syncId);
                if (!target) {
                    Loading.hide();
                    return;
                }
                const result = new RsyncResult();
                result.syncId = target.syncId;
                result.targetOperation = target.targetOperation;
                result.identityCode = target.identifyCode;
                result.userCd = target.userCd;
                result.buknCd = target.buknCd;
                result.nyukyokeiyakuNo = target.nyukyokeiyakuNo;
                // RsyncConditionViewModel を作成
                const condition = new RsyncConditionViewModel(result);
                await adminApi.rsync.rsync(condition);
                await MsgBox.info(commonStore.messages.PI0017);
            }
            catch (ex) {
                log.error("rsync", ex);
                await MsgBox.error(ex.data.errorMessage);
            }
            finally {
                Loading.hide();
                initView();
            }
        };
        initView();
        return {
            ...toRefs(store),
            onSearch,
            onRequest,
            columns,
            expansionState: ref(false),
            targetOperationList,
            TargetOperation,
            onRsync,
            pageName,
            top,
            resync
        };
    }
});
